import { createApi } from "@reduxjs/toolkit/query/react";
import { customBaseQuery } from "./common";
import { Quota } from "../../schema/types/quota";

export const quotaApi = createApi({
  reducerPath: "quotaApi",
  baseQuery: customBaseQuery,
  tagTypes: ["Quota"],
  endpoints: (builder) => ({
    getQuota: builder.query<Quota, string>({
      queryFn: async (link) => {
        try {
          const { request } = await import("../../services/cpln");
          const { data } = await request({ url: link });
          return { data };
        } catch (error: any) {
          return {
            error: {
              status: error.response?.status || 500,
              data: error.response?.data || error.message,
            },
          };
        }
      },
      providesTags: (result, error, link) => [{ type: "Quota", id: link }],
    }),
  }),
});

export const { useGetQuotaQuery } = quotaApi;
